import { NgClass } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import type { TextPreset, TextPresetCompounds } from '../email-text/email-text.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-link',
  styleUrls: ['./email-link.component.less'],
  template: `<a
    [href]="prefix + href.toJSON()"
    [target]="target"
    [ngClass]="'link-' + (textOpts?.color || 'primary')"
  >
    <email-text
      [contents]="label"
      [size]="textOpts?.size"
      [behavior]="textOpts?.behavior"
      [vAlign]="textOpts?.vAlign"
      [bold]="textOpts?.bold"
      [color]="textOpts?.color"
      [presetName]="textPreset"
    />
  </a>`,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, EmailTextComponent],
})
export class EmailLinkComponent {
  @Input() public href: WrappedValue<string>;
  @Input() public label: WrappedValue<string>;
  @Input() public prefix: string = '';
  @Input() public target?: string = '_blank';
  @Input() public textOpts?: TextPresetCompounds;
  @Input() public textPreset?: TextPreset;
}
